import { trackEvent } from "web/core/analytics";

export default trackEvent;
